(function () {
  var CONSENT_KEY = 'Zgoda na natychmiastowa dostawe';

  function drawer() { return document.querySelector('[data-cart-drawer]'); }

  function open() {
    var d = drawer();
    if (!d) return;
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var close = d.querySelector('[data-drawer-close]');
    if (close) close.focus();
  }
  function close() {
    var d = drawer();
    if (!d) return;
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function refresh(andOpen) {
    return fetch(window.Shopify.routes.root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-cart-drawer]');
        var current = drawer();
        if (fresh && current) {
          var wasOpen = current.getAttribute('aria-hidden') === 'false';
          current.replaceWith(fresh);
          if (wasOpen || andOpen) open();
        }
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = tmp.querySelector('[data-cart-total-count]')
            ? tmp.querySelector('[data-cart-total-count]').textContent
            : el.textContent;
        });
      });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function add(id, replaceCart) {
    var chain = replaceCart ? fetch(window.Shopify.routes.root + 'cart/clear.js', { method: 'POST' }) : Promise.resolve();
    return chain
      .then(function () { return post(window.Shopify.routes.root + 'cart/add.js', { items: [{ id: id, quantity: 1 }] }); })
      .then(function () { return refresh(true); });
  }

  function moveCross(dir) {
    var slides = Array.prototype.slice.call(document.querySelectorAll('[data-cs-slide]'));
    if (slides.length < 2) return;
    var current = 0;
    slides.forEach(function (s, i) { if (!s.hasAttribute('hidden')) current = i; });
    var next = (current + dir + slides.length) % slides.length;
    slides.forEach(function (s, i) {
      if (i === next) { s.removeAttribute('hidden'); } else { s.setAttribute('hidden', 'hidden'); }
    });
    var label = document.querySelector('[data-cs-count]');
    if (label) label.textContent = (next + 1) + '/' + slides.length;
  }

  function changeLine(el, quantity) {
    var inDrawer = !!el.closest('[data-cart-drawer]');
    el.setAttribute('disabled', 'disabled');
    return post(window.Shopify.routes.root + 'cart/change.js', { line: Number(el.getAttribute('data-line')), quantity: quantity })
      .then(function () {
        if (inDrawer) return refresh(false);
        window.location.reload();
      });
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-add-to-cart]');
    if (addBtn) {
      e.preventDefault();
      var id = addBtn.getAttribute('data-variant-id');
      if (!id) return;
      addBtn.setAttribute('disabled', 'disabled');
      add(id, addBtn.hasAttribute('data-replace-cart')).then(function () {
        addBtn.removeAttribute('disabled');
      });
      return;
    }
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refresh(true); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-drawer-scrim]')) { e.preventDefault(); close(); return; }
    var nav = e.target.closest('[data-cs-nav]');
    if (nav) {
      e.preventDefault();
      moveCross(Number(nav.getAttribute('data-dir')) || 1);
      return;
    }
    var csAdd = e.target.closest('[data-cs-add]');
    if (csAdd) {
      e.preventDefault();
      var slide = document.querySelector('[data-cs-slide]:not([hidden])');
      if (!slide) return;
      csAdd.setAttribute('disabled', 'disabled');
      add(slide.getAttribute('data-variant-id'), false);
      return;
    }
    var qtyBtn = e.target.closest('[data-line-qty]');
    if (qtyBtn) {
      e.preventDefault();
      changeLine(qtyBtn, Math.max(0, Number(qtyBtn.getAttribute('data-qty'))));
      return;
    }
    var rm = e.target.closest('[data-line-remove]');
    if (rm) {
      e.preventDefault();
      changeLine(rm, 0);
    }
  });

  document.addEventListener('change', function (e) {
    var box = e.target.closest('[data-consent]');
    if (!box) return;
    var label = box.closest('.consent');
    var pay = document.querySelector('[data-checkout]');
    var note = document.querySelector('[data-consent-note]');
    if (label) label.setAttribute('data-checked', box.checked ? 'true' : 'false');
    if (pay) { if (box.checked) { pay.removeAttribute('disabled'); } else { pay.setAttribute('disabled', 'disabled'); } }
    if (note) {
      note.textContent = box.getAttribute(box.checked ? 'data-note-on' : 'data-note-off') || note.textContent;
      note.classList.toggle('btn-note--alert', !box.checked);
    }
    var express = document.querySelector('[data-express-buttons]');
    if (express) {
      express.style.opacity = box.checked ? '' : '.4';
      express.style.pointerEvents = box.checked ? '' : 'none';
    }
    var attrs = {};
    attrs[CONSENT_KEY] = box.checked ? 'tak' : '';
    post(window.Shopify.routes.root + 'cart/update.js', { attributes: attrs });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();
